import React from "react";
import { returnEnvironment } from "../../utils";

const environment = returnEnvironment();
const OmniContent = require(`../../components/OmniContent/${environment}`).OmniContent;

export const Onboarding = ({ comunidade }) => {
    return <OmniContent comunidade={comunidade} />;
};
